import React, { useState } from 'react';
import './Gallery.css'; // Reuse your main styles
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import Footer from '../components/Footer';
import heroImg from '../assets/about/hero-3.jpg';
import { Link } from 'react-router-dom';

const IMAGES_PER_PAGE = 6; // You can change this as needed

const galleryImages = [
  '/gallery/gallery1.jpg',
  '/gallery/gallery2.jpg',
  '/gallery/gallery3.jpg',
  '/gallery/gallery4.jpg',
  '/gallery/gallery5.jpg',
  '/gallery/gallery6.jpg',
  '/gallery/gallery7.jpg',
  '/gallery/gallery8.jpg',
  '/gallery/gallery9.jpg',
  '/gallery/gallery10.jpg',
  '/gallery/gallery11.jpg',
  '/gallery/gallery12.jpg',
];





const galleryVideos = [
  {
    type: 'youtube',
    id: 'ezlGCfIIK1k',
  },
  {
    type: 'youtube',
    id: 'SqotPzgR_Yg',
  },
  {
    type: 'youtube',
    src: 'y3BOY8f6IDs',
  },
];

const Gallery = () => {
	const [currentPage, setCurrentPage] = useState(1);
const totalPages = Math.ceil(galleryImages.length / IMAGES_PER_PAGE);
const startIndex = (currentPage - 1) * IMAGES_PER_PAGE;
const currentImages = galleryImages.slice(startIndex, startIndex + IMAGES_PER_PAGE);
  return (
    <div className="about-page">
       <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

      {/* Page Title */}
      <section className="about-hero">
	   <img src={heroImg} alt="Universal Academy Campus" />
        <div className="hero-text">
          <h1>Gallery</h1>
          <p>Explore glimpses of student life, celebrations, and school achievements</p>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="about-intro">
        <h2>Photo </h2>
        <p>Here are some of the wonderful moments captured at Universal Academy.</p>
      </section>

<section className="gallery-grid">
  {/* ✅ Image Grid */}
  <div className="gallery-wrapper">
    {currentImages.map((img, idx) => (
      <div className="gallery-card" key={idx}>
        <img src={img} alt={`Gallery ${idx + 1}`} />
      </div>
    ))}
  </div>

  {/* ✅ Pagination — OUTSIDE the .gallery-wrapper */}
  <div className="gallery-pagination">
  <button
    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
    disabled={currentPage === 1}
  >
    &laquo; Prev
  </button>

  <span className="page-number">
    Page <strong>{currentPage}</strong> of {totalPages}
  </span>

  <button
    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
    disabled={currentPage === totalPages}
  >
    Next &raquo;
  </button>
</div>
</section>





      {/* Video Gallery */}
      <section className="about-intro">
        <h2>Videos</h2>
        <p>Events, performances and more...</p>
      </section>

      <section className="gallery-grid">
        <div className="gallery-wrapper">
          {galleryVideos.map((video, idx) => (
            <div className="gallery-card" key={idx}>
              {video.type === 'youtube' ? (
                <iframe
                  width="100%"
                  height="300"
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={`YouTube video ${idx}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <video width="100%" height="300" controls>
                  <source src={video.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default Gallery;
